module.exports = __webpack_public_path__ + "img/skilledHand_logo.35b1e004.png";